import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// components
import Loading from '../../components/atom/loading/Loading'
import Paging from '../../components/pagination/Paging'
import { Empty } from '../reviewList/components'

// globals
import * as TYPE from '../../globals/type'
import * as constants from '../../globals/constants'

// utils
import { useAxios } from '../../utils/useAxios'

// styles
import colors from '../../styles/colors'

// images
import NewButton from '../../assets/image/button/ico-new.svg'

const NoticeList = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const { fetchData, loading, data } = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const [noticeItem, setNoticeItem] = useState({ total: 0, list: null })

  // 페이지네이션
  const [page, setPage] = useState(location?.state?.prevNum ?? 1)

  useEffect(() => {
    getNoticeList()
  }, [page])

  //공지사항 목록 데이터 처리
  useEffect(() => {
    let resData = data?.responseData ?? null
    if (data?.responseCode === TYPE.API_RESPONSE.SUCCESS && resData) {
      setNoticeItem({
        total: resData.noticeListCount,
        list: resData.noticeList,
      })
    }
  }, [data])

  // API: 공지사항 목록
  const getNoticeList = () => {
    const params = {
      startNo: 10 * (page - 1) + 1,
      endNo: 10 * page,
      allSelect: 'Y',
    }

    fetchData(constants.API.NOTICE_LIST, 'GET', null, params)
  }

  const getNoticeDetailPage = (item) => {
    if (!item?.noticeId) return
    navigate(`/happyOrderNoticeList/${item.noticeId}`, {
      replace: false,
      state: {
        pageNum: page,
        modified: item.modified,
      },
    })
  }

  return (
    <>
      {loading && noticeItem.total === 0 ? (
        <Loading />
      ) : noticeItem.total === 0 || noticeItem.list.length === 0 ? (
        <Wrapper>
          <Empty pointTxt={'등록된 공지사항'} txt={'이 없습니다.'} />
        </Wrapper>
      ) : (
        <>
          <NoticePCWrapper>
            <NoticePC>
              <HeadNoticePc>
                <div>번호</div>
                <div>제목</div>
                <div>등록일</div>
                <div>작성자</div>
              </HeadNoticePc>

              {noticeItem.list.map((item, i) => {
                const parsedDate = moment(item.modified, 'YYYYMMDDHHmmss')
                // const today = moment().format('YYYY-MM-DD')
                const itemNumber = noticeItem.total - (page - 1) * 10 - i

                if (itemNumber > 0) {
                  return (
                    <BodyNoticePc
                      key={i}
                      onClick={() => getNoticeDetailPage(item)}
                    >
                      <div>{itemNumber}</div>
                      <div>
                        {item.readYn !== 'Y' && <img src={NewButton} alt="" />}

                        <span>{item.ntcTitle}</span>
                      </div>
                      <div>{parsedDate.format('YYYY-MM-DD')}</div>
                      <div>해피오더 관리자</div>
                    </BodyNoticePc>
                  )
                } else {
                  return <></>
                }
              })}
            </NoticePC>
          </NoticePCWrapper>
          {noticeItem.list.map((item, i) => {
            const parsedDate = moment(item.modified, 'YYYYMMDDHHmmss')
            const formatDate = parsedDate.format('YYYY-MM-DD')
            // const today = moment().format('YYYY-MM-DD')
            const itemNumber = noticeItem.total - (page - 1) * 10 - i

            if (itemNumber > 0) {
              return (
                <NoticeMoWrapper
                  onClick={() => getNoticeDetailPage(item)}
                  key={i}
                >
                  <NoNotice>{itemNumber}</NoNotice>
                  <ContentsNotice>
                    <div>해피오더 관리자</div>
                    <div>{formatDate}</div>
                    <div>
                      {item.readYn !== 'Y' && <img src={NewButton} alt="" />}
                      <span>{item.ntcTitle}</span>
                    </div>
                  </ContentsNotice>
                </NoticeMoWrapper>
              )
            } else {
              return <></>
            }
          })}

          <Paging
            page={page}
            count={noticeItem?.total ?? 0}
            setPage={(e) => setPage(e)}
            isTemp={true}
            tableSize={10}
            marginTop={[40, 40]}
          />
        </>
      )}
    </>
  )
}

export default NoticeList

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
const NoticePCWrapper = styled.div`
  flex-direction: column;
  width: 100%;
  -webkit-box-align: center;
  align-items: center;
  position: relative;
`
const NoticePC = styled.div`
  display: flex;
  flex-direction: column;
  height: 910px;
  max-width: 768px;
  margin: 0px auto;
  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`

const HeadNoticePc = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  background-color: ${colors.W4};
  border-top: 1px solid ${colors.G3};
  border-bottom: 1px solid ${colors.G3};

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: ${colors.D3};
  }

  div:nth-child(1) {
    width: 10%;
  }

  div:nth-child(2) {
    width: 54%;
  }

  div:nth-child(3) {
    width: 18%;
  }

  div:nth-child(4) {
    width: 18%;
  }
`

const BodyNoticePc = styled.div`
  display: flex;
  height: 86px;
  cursor: pointer;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: ${colors.BK};
  }

  div:nth-child(1) {
    width: 10%;
  }

  div:nth-child(2) {
    width: 54%;
    display: flex;
    justify-content: flex-start;
    padding: 0 8px;

    img {
      width: 40px;
      height: 20px;
      margin-right: 10px;
    }

    span {
      flex: 1;
      line-height: 1.5;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  div:nth-child(3) {
    width: 18%;
  }

  div:nth-child(4) {
    width: 18%;
  }
`

const NoticeMoWrapper = styled.div`
  display: none;
  padding: 0 20px;
  cursor: pointer;

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    display: flex;
    align-items: center;
    border-top: 1px solid ${colors.G5};
    border-bottom: 1px solid ${colors.G5};
  }
`

const NoNotice = styled.div`
  font-size: 14px;
  color: ${colors.BK};
`

const ContentsNotice = styled.div`
  margin-left: 25px;
  padding: 30px 0;
  flex: 1;
  display: flex;
  flex-direction: column;

  div:nth-child(1) {
    font-size: 12px;
    margin-bottom: 8px;
    color: ${colors.BK};
  }

  div:nth-child(2) {
    font-size: 12px;
    margin-bottom: 15px;
    color: ${colors.G4};
  }

  div:nth-child(3) {
    display: flex;
    align-items: center;

    font-size: 14px;
    font-weight: 700;
    color: ${colors.BK};
    line-height: 1.5;

    img {
      margin-right: 5px;
      width: 40px;
      height: 20px;
    }
  }
`
